import ResetPasswordContent from "../../../modules/Login/components/ResetPasswordContent";
import { Loader } from "../../../components/Loader/Loader";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getIsCheckCodeLoading } from "../../../app/appSelectors";
import { MobileAppResetPasswordStyled } from "./styled/MobileAppResetPasswordStyled";
import { MobileRouterPaths } from "../../mobileAppConstants";
import { useCallback } from "react";
import appHistory from "../../../app/appHistory";

function MobileAppResetPassword(props) {
    const {
        isCheckCodeLoading,
    } = props;

    const handleUpdateSuccessCallback = useCallback(() => {
        appHistory.push(MobileRouterPaths.default);
    }, []);

    return <MobileAppResetPasswordStyled>
        <div className="d-flex flex-column w-100">
            <ResetPasswordContent
                failureRedirectLink={MobileRouterPaths.brokenLink}
                onUpdateSuccessCallback={handleUpdateSuccessCallback}
            />
        </div>
        <Loader show={isCheckCodeLoading}/>
    </MobileAppResetPasswordStyled>
}

const mapStateToProps = createStructuredSelector({
    isCheckCodeLoading: getIsCheckCodeLoading,
});

export default connect(mapStateToProps)(MobileAppResetPassword);
